import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { CompanyProvider, useCompany } from './context/CompanyContext';
import { UserProvider } from './context/UserContext';
import { ChatProvider } from './context/ChatContext';
import { AdProvider } from './context/AdContext';
import Layout from './components/Layout';
import AdOverlay from './components/AdOverlay';
import { ToastContainer } from './components/UI';

import OnboardingScreen from './screens/OnboardingScreen';
import HomeScreen from './screens/HomeScreen';
import ChatScreen from './screens/ChatScreen';
import ServicesScreen from './screens/ServicesScreen';
import EventsScreen from './screens/EventsScreen';
import FlightsScreen from './screens/FlightsScreen';
import MyBookingsScreen from './screens/MyBookingsScreen';
import ProfileScreen from './screens/ProfileScreen';
import BookingConfirmScreen from './screens/BookingConfirmScreen';

function AppRoutes() {
    const { company, loading } = useCompany();
    if (loading) return null;

    if (!company) {
        return (
            <Routes>
                <Route path="*" element={<OnboardingScreen />} />
            </Routes>
        );
    }

    return (
        <>
            <AdOverlay />
            <Routes>
                {/* Full screen routes (no bottom nav) */}
                <Route path="/chat" element={<ChatScreen />} />
                <Route path="/booking-confirm" element={<BookingConfirmScreen />} />
                <Route path="/profile" element={
                    <div style={{
                        maxWidth: 560, margin: '0 auto', minHeight: '100vh',
                        backgroundColor: 'var(--bg-primary)', overflowY: 'auto'
                    }}>
                        <ProfileScreen />
                    </div>
                } />

                {/* Main layout with bottom nav */}
                <Route path="/*" element={
                    <Layout>
                        <Routes>
                            <Route path="/" element={<HomeScreen />} />
                            <Route path="/services" element={<ServicesScreen />} />
                            <Route path="/events" element={<EventsScreen />} />
                            <Route path="/flights" element={<FlightsScreen />} />
                            <Route path="/bookings" element={<MyBookingsScreen />} />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </Layout>
                } />
            </Routes>
        </>
    );
}

export default function App() {
    return (
        <BrowserRouter>
            <CompanyProvider>
                <UserProvider>
                    <ChatProvider>
                        <AdProvider>
                            <AppRoutes />
                            <ToastContainer />
                        </AdProvider>
                    </ChatProvider>
                </UserProvider>
            </CompanyProvider>
        </BrowserRouter>
    );
}
